export default __webpack_public_path__ + "static/media/logo.8eb6094e.png";